<template>
  <div v-if="isShowModel" class="assign_confirm_contianer">
    <div class="assign_model">
      <div class="model_header">
        <span>{{title}}</span>
        <i v-if="showClose" @click="cancel" class="iconfont iconxd-zt-cw"></i>
      </div>
      <div class="model_body">
        {{content}}
      </div>
      <div class="model_footer">
        <el-button v-if="cancelTxt" @click="cancel" class="el_common_button white small">{{cancelTxt}}</el-button>
        <el-button v-if="confirmTxt" @click="confirm" class="el_common_button small">{{confirmTxt}}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dialog',
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    content: {
      type: String,
      required: false,
      default: ''
    },
    cancelTxt: {
      type: String,
      required: false,
      default: ''
    },
    confirmTxt: {
      type: String,
      required: false,
      default: ''
    },
    showClose: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      isShowModel: false,

      promise: null,

      resolve: null,

      reject: null
    }
  },

  methods: {
    confirm () {
      this.isShowModel = false
      this.resolve('confirm')
      this.remove()
    },

    cancel () {
      this.isShowModel = false
      this.reject('cancel')
      this.remove()
    },

    showModel () {
      this.isShowModel = true
      this.promise = new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
      return this.promise
    },

    remove () {
      setTimeout(() => {
        this.destroy()
      }, 300)
    },

    destroy () {
      this.$destroy()
      document.body.removeChild(this.$el)
    }
  }
}
</script>

<style lang="scss" scoped>
  .assign_confirm_contianer {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 99999;

    display: flex;
    align-items: center;
    justify-content: center;

    background-color: rgba(0, 0, 0, .3);
    .assign_model {
      width: 500px;

      border-radius: 8px;
      background-color: #fff;
      box-shadow: 0px 4px 20px 0px rgba(0,0,0,0.25);
      .model_header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        width: 100%;
        height: 50px;
        padding: 0 20px;

        border-bottom: 1px solid #E6E7F0;
        box-sizing: border-box;
        span {
          font-size: 15px;
          font-weight: 600;
          color: #33394E;
        }
        i {
          font-size: 20px;
          color: #A5A8B7;
          cursor: pointer;
        }
      }
      .model_body {
        padding: 30px;
        padding-top: 25px;

        color: #33394E;
        font-size: 14px;
      }
      .model_footer {
        padding: 0 30px;
        margin-bottom: 25px;
        text-align: right;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/model_dialog/dialog.vue